import { useContext } from 'react';
import { CallsChartsDataContext } from '../contexts/CallsChartsDataContext';

export const useCallsChartsDataContext = () => {
    return useContext(CallsChartsDataContext);
};
